import Vue from 'vue';
import Vuex from 'vuex';
import dialog from './modules/dialog';
import inventumSettings from './modules/inventum-settings';
import toast from './modules/toast';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const createStore = () =>
  new Vuex.Store({
    modules: {
      dialog,
      inventumSettings,
      toast,
    },
    strict: debug,
  });

export default createStore;
